var map = {
	"./afb-color.svg": 646,
	"./alb-color.svg": 647,
	"./all.svg": 648,
	"./amb-color.svg": 649,
	"./arg.svg": 650,
	"./aus.svg": 651,
	"./bank-icon.svg": 652,
	"./bankdemo-color.svg": 653,
	"./bel.svg": 654,
	"./bimb-color.svg": 655,
	"./bkr-color.svg": 656,
	"./bpay-color.svg": 657,
	"./bra.svg": 658,
	"./bsn-color.svg": 659,
	"./can.svg": 660,
	"./checked-white.png": 661,
	"./cimb-color.svg": 662,
	"./cimb-icon.svg": 663,
	"./citi-color.svg": 664,
	"./cmr.svg": 665,
	"./crc.svg": 666,
	"./cro.svg": 667,
	"./den.svg": 668,
	"./ecu.svg": 669,
	"./eng.svg": 670,
	"./esp.svg": 671,
	"./esports-active-m.svg": 672,
	"./esports-m.svg": 673,
	"./fav-gray.png": 674,
	"./fav-icon-active.png": 675,
	"./fav-icon.png": 676,
	"./fav-red.png": 677,
	"./fra.svg": 678,
	"./game-icon.svg": 679,
	"./games-active-m.svg": 680,
	"./games-m.svg": 681,
	"./ger.svg": 682,
	"./gha.svg": 683,
	"./gxbank-color.svg": 684,
	"./hlb-color.svg": 685,
	"./hlb-icon.svg": 686,
	"./hsbc-color.svg": 687,
	"./irn.svg": 688,
	"./jpn.svg": 689,
	"./kor.svg": 690,
	"./ksa.svg": 691,
	"./kwh-color.svg": 692,
	"./latest-icon-active.png": 693,
	"./latest-icon.png": 694,
	"./lc-active-m.svg": 695,
	"./lc-icon.svg": 696,
	"./lc-m.svg": 697,
	"./lottery-active-m.svg": 698,
	"./lottery-icon.svg": 699,
	"./lottery-m.svg": 700,
	"./love.svg": 701,
	"./mar.svg": 702,
	"./mbb-color.svg": 703,
	"./mex.svg": 704,
	"./ned.svg": 705,
	"./ocbc-color.svg": 706,
	"./ocbc-icon.svg": 707,
	"./p2p-active-m.svg": 708,
	"./p2p-icon.svg": 709,
	"./p2p-m.svg": 710,
	"./pbb-color.svg": 711,
	"./pol.svg": 712,
	"./por.svg": 713,
	"./price-high.svg": 714,
	"./price-low.svg": 715,
	"./qat.svg": 716,
	"./rhb-color.svg": 717,
	"./rhb-icon.svg": 718,
	"./scb-color.svg": 719,
	"./sen.svg": 720,
	"./slot-active-m.svg": 721,
	"./slot-icon.svg": 722,
	"./slot-m.svg": 723,
	"./speed-active-m.svg": 724,
	"./speed-m.svg": 725,
	"./sport-active-m.svg": 726,
	"./sport-m.svg": 727,
	"./sports-icon.svg": 728,
	"./square-icon.svg": 729,
	"./srb.svg": 730,
	"./star.svg": 731,
	"./sui.svg": 732,
	"./tng-color.svg": 733,
	"./trx-icon.svg": 734,
	"./trx.svg": 735,
	"./tun.svg": 736,
	"./uefa-icon.svg": 737,
	"./uob-color.svg": 738,
	"./uru.svg": 739,
	"./usa.svg": 740,
	"./usdc.svg": 741,
	"./usdt.svg": 742,
	"./ustd-icon.svg": 743,
	"./wal.svg": 744,
	"./x33-logo-b.svg": 745,
	"./x33-square-icon.svg": 746
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1671;